import React, { useState, useEffect, useCallback } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { CreateTable } from "./../ManageTable";
import {
  CreateButton,
  CreateSearchBarWithPlaceHolder,
} from "./../CommonObjects";
import { CreateTableForEmployeeSelect } from "./../ManageTable";
import loadingSpinner from "./../../assets/loading.gif";
import axios from '../../api/apiClient';
import { token, domain } from "./../Security";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

function OffsetCredits({ user, userAccess, isHideSideMenu }) {
  const [employee, setEmployee] = useState(
    user.employeePersonalInformationFullName
  );
  const [employeeId, setEmployeeId] = useState(
    user.employeePersonalInformationId
  );

  const [loading, setLoading] = useState(false);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);

  const [selectedTab, setSelectedTab] = useState(0);
  const [currentPage_overtime, setCurrentPage_overtime] = useState(1);
  const [currentPage_leave, setCurrentPage_leave] = useState(1);

  const [overtimeData, setOvertimeData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);

  var header_overtime = [
    "Employee Id",
    "Employee",
    "Date",
    "Hours Exceeded",
    "Used",
    "On Hold",
    "Remaining",
  ];
  var accessor_overtime = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "date",
    "hours",
    "useValue",
    "holdValue",
    "remainingValue",
  ];

  var header_leave = [
    "Employee Id",
    "Employee",
    "Leave Type",
    "Date From",
    "Date To",
    "Days",
    "Used",
    "On Hold",
    "Remaining",
  ];
  var accessor_leave = [
    "employeePersonalInformationEmployeeId",
    "employeePersonalInformationFullName",
    "leaveData.leaveTypeDescription",
    "leaveData.dateFrom",
    "leaveData.dateTo",
    "leaveData.days",
    "useValue",
    "holdValue",
    "remainingValue",
  ];

  const handleSelectChange = (index) => {
    setCurrentPage_overtime(1);
    setCurrentPage_leave(1);
    setSelectedTab(index);
  };

  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };

  const fetchDataOvertime = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetOvertime/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);
  const fetchDataLeave = useCallback(async () => {
    const apiUrl = domain + `/api/OffsetLeave/employee/${employeeId}`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  }, [employeeId]);

  const fetchData = useCallback(async () => {
    setLoading(true);

    const _overtimeData = await fetchDataOvertime();
    const _leaveDate = await fetchDataLeave();

    setOvertimeData(_overtimeData);
    setLeaveData(_leaveDate);

    setLoading(false);
  }, [fetchDataOvertime, fetchDataLeave]);

  const [isGenerate, setIsGenerate] = useState(true);

  const generate = () => {
    setIsGenerate(true);
  };

  useEffect(() => {
    if (isGenerate) {
      fetchData();
      setIsGenerate(false);
    }
  }, [isGenerate, fetchData]);

  return (
    <>
      <div>
        <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
          <div className="LeftSpace"></div>
          <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
            <div className="TransactionInfo Transaction-Form-Info shadow-xl">
              <div className="transaction-header">
                <div className="sub-title row">
                  <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                    {"Transactions >"}{" "}
                  </span>
                  <span style={{ borderBottom: "1px solid black" }}>
                    {"Offset Credits"}
                  </span>
                </div>
                <div
                  className="row"
                  style={{
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h3>Offset Credits</h3>
                </div>
              </div>
              <div className="transaction-body loan-tab">
                <div
                  className="transaction-from-splitItem row"
                  style={{ alignItems: "center" }}
                >
                  <div className="column" style={{ width: "100%" }}>
                    <div className="transaction-form-item row">
                      <div
                        className="transaction-form-category"
                        style={{ width: "90px" }}
                      >
                        <h4>Employee</h4>
                      </div>
                      <div className="transaction-form-input">
                        <div
                          className="info-item-holder employee-select row"
                          style={{
                            flexDirection: "row",
                            justifyContent: "normal",
                          }}
                        >
                          <input
                            readOnly
                            className="employeeInput-select"
                            placeholder="Employee"
                            value={employee ? employee : employee}
                          />
                          <button
                            className="select row"
                            onClick={() => setShowEmployeeForm(true)}
                            style={{
                              visibility:
                                userAccess.description === "Admin" ||
                                userAccess.description === "HR Head" ||
                                userAccess.description === "HR Assistant" ||
                                userAccess.description === "HR Assistant2" ||
                                userAccess.description === "HR Assistant3" ||
                                userAccess.description === "HR Manager"
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            <SearchIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="column" style={{ width: "100%" }}>
                    <div
                      className="generate-button-offset"
                      style={{
                        visibility:
                          userAccess.description === "Admin" ||
                          userAccess.description === "HR Head" ||
                          userAccess.description === "HR Assistant" ||
                          userAccess.description === "HR Assistant2" ||
                          userAccess.description === "HR Assistant3" ||
                          userAccess.description === "HR Manager"
                            ? "visible"
                            : "hidden",
                      }}
                    >
                      {CreateButton(
                        "overtime-add-button",
                        "submit",
                        generate,
                        "GENERATE",
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <Tabs
                  selectedIndex={selectedTab}
                  onSelect={(index) => handleSelectChange(index)}
                >
                  <TabList>
                    <Tab>
                      <b>OVERTIME</b>
                    </Tab>
                    <Tab>
                      <b>LEAVE</b>
                    </Tab>
                  </TabList>
                  <TabPanel>
                    <div style={{ padding: "20px 0", display: "none" }}>
                      <span
                        style={{
                          padding: "10px",
                          background: "white",
                          border: "1px solid #aaa",
                          borderRadius: "5px",
                        }}
                      >{`Offset Hours: ${overtimeData.totalHours?.toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}`}</span>
                    </div>
                    <div className="transaction-table container">
                      <CreateTable
                        dataList={overtimeData?.data ?? []}
                        dataHeader={header_overtime}
                        dataAccessor={accessor_overtime}
                        // editHandleClick={editHandleClick}
                        currentPage={currentPage_overtime}
                        setCurrentPage={setCurrentPage_overtime}
                      />
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div style={{ padding: "20px 0", display: "none" }}>
                      <span
                        style={{
                          padding: "10px",
                          background: "white",
                          border: "1px solid #aaa",
                          borderRadius: "5px",
                        }}
                      >{`Offset Days: ${leaveData.totalDays?.toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}`}</span>
                    </div>
                    <div className="transaction-table container">
                      <CreateTable
                        dataList={leaveData?.data ?? []}
                        dataHeader={header_leave}
                        dataAccessor={accessor_leave}
                        // editHandleClick={editHandleClickBeneficiary}
                        // deleteHandleClick={deleteHandleClick}
                        currentPage={currentPage_leave}
                        setCurrentPage={setCurrentPage_leave}
                      />
                    </div>
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>

      <EmployeeSelectForm
        isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeeId}
        setEmployee={setEmployee}
      ></EmployeeSelectForm>

      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

function EmployeeSelectForm({ isOpen, onClose, setEmployeeId, setEmployee }) {
  var header = ["Id", "Name"];
  var accessor = ["employeeId", "fullName"];

  const handleClose = () => {
    onClose();
    fetchData();
  };
  const handleProceed = () => {
    onClose();
    setEmployeeId(selectedEmployee.id);
    setEmployee(selectedEmployee.fullName);
    fetchData();
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterDataIndex, setFilterDataIndex] = useState(0);
  const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

  const fetchData = async () => {
    const apiUrl = domain + "/api/Employee/basic-info/all/active";

    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json", // You can include other headers if needed
        },
      });
      setEmployees(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Set loading state to false after data fetching is complete
    }
  };
  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = [];

    switch (filterDataIndex) {
      case 0:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );
        break;
      case 1:
        res = filterData.filter((f) =>
          f.employeeId.toString().startsWith(lowercaseValue)
        );
        break;
      default:
        res = filterData.filter((f) =>
          f.fullName.toLowerCase().includes(lowercaseValue)
        );

        break;
    }

    setEmployees(res);
  };

  useEffect(() => {
    switch (filterDataIndex) {
      case 0:
        setSearchPlaceholder("Search by name");
        break;
      case 1:
        setSearchPlaceholder("Search by id");
        break;
      default:
        setSearchPlaceholder("Search by name");
        break;
    }
    fetchData();
  }, [filterDataIndex]);

  return (
    <>
      <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Select Employee</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="transaction-body">
              <EmployeeFilter setFilterDataIndex={setFilterDataIndex} />
              <div className="transaction-body-top row">
                {CreateSearchBarWithPlaceHolder(
                  "",
                  "transaction-search row",
                  "transaction-search-icon",
                  "transaction-search-input",
                  (e) => handleFilter(e.target.value),
                  searchPlaceholder,
                  SearchIcon
                )}
              </div>
            </div>
            <div className="popUp-body">
              <div className="select-employee-table">
                <CreateTableForEmployeeSelect
                  dataList={employees}
                  dataHeader={header}
                  dataAccessor={accessor}
                  setSelectedEmployee={setSelectedEmployee}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
                {employees.length > 0 ? (
                  <div></div>
                ) : (
                  <div>
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "10vh",
                        }}
                      >
                        <img src={loadingSpinner} alt="Loading..." />
                      </div>
                    ) : (
                      <div> {/*<p>No records to display</p>*/}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div
              className="buttons row"
              style={{ justifyContent: "end", padding: "50px 20px 0 20px" }}
            >
              <button
                id="add-family"
                className="save row"
                onClick={handleProceed}
              >
                PROCEED
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
function EmployeeFilter({ setFilterDataIndex }) {
  const [selectedOption, setSelectedOption] = useState("All");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);

    switch (event.target.value) {
      case "All":
        setFilterDataIndex(0);
        break;
      case "EmployeeId":
        setFilterDataIndex(1);
        break;
      default:
        setFilterDataIndex(0);
        break;
    }
  };

  return (
    <div className="filters row" style={{ alignItems: "center" }}>
      <span style={{ marginRight: "10px" }}>Filter</span>
      <select
        id=""
        className="filterSelect"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="All">All</option>
        <option value="EmployeeId">Employee Id</option>
      </select>
    </div>
  );
}

export default OffsetCredits;
